/** @jsx jsx */
/** @jsxFrag null */
import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { LocalizationStore } from 'common/i18n/store';
export function DashboardFavoriteButton(_ref: {
  isSelected?: boolean;
  isLoading?: boolean;
  onClick: (ev: MouseEvent) => void;
  i18n: LocalizationStore;
}) {
  let {
    isSelected,
    isLoading,
    onClick,
    i18n
  }: {
    isSelected?: boolean;
    isLoading?: boolean;
    onClick: (ev: MouseEvent) => void;
    i18n: LocalizationStore;
  } = _ref;
  const {
    t
  } = i18n;
  return <ButtonEl attrs={{
    elref: "favoriteButton",
    slot: "favoriteButton",
    theme: ButtonTheme.Tertiary,
    'highlight-icon': isSelected,
    icon: isLoading ? "spinner" : isSelected ? "filled-heart" : "heart",
    disabled: isLoading,
    tooltip: {
      text: isSelected ? t("boards.actions.favorited") : t("boards.actions.favorite")
    }
  }} on={{
    click: onClick
  }} data-sentry-element="ButtonEl" data-sentry-component="DashboardFavoriteButton" data-sentry-source-file="buttons.tsx" />;
}